"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toggleTagCore_1 = require("../utils/toggleTagCore");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var PRE_TAG = 'pre';
var CODE_TAG = 'code';
var CODE_NODE_TAG = 'CODE';
/**
 * Toggle code block at selection, if selection already contains any code blocked elements,
 * the code block elements will be no longer be code blocked and other elements will take no affect
 * @param editor The editor instance
 * @param styler (Optional) The custom styler for setting the style for the code block element
 */
function toggleCodeBlock(editor, styler) {
    toggleTagCore_1.default(editor, PRE_TAG, styler, wrapFunction, unwrapFunction);
}
exports.default = toggleCodeBlock;
function wrapFunction(nodes) {
    var codeBlock = roosterjs_editor_dom_1.wrap(nodes, CODE_TAG);
    return roosterjs_editor_dom_1.wrap(codeBlock, PRE_TAG);
}
function unwrapFunction(node) {
    if (!node) {
        return null;
    }
    var firstChild = node.childNodes[0];
    if (node.childNodes.length == 1 && roosterjs_editor_dom_1.getTagOfNode(firstChild) == CODE_NODE_TAG) {
        roosterjs_editor_dom_1.unwrap(firstChild);
    }
    return roosterjs_editor_dom_1.unwrap(node);
}
//# sourceMappingURL=toggleCodeBlock.js.map